import React from 'react';
import { Link } from 'react-router-dom';

const EmptyState = ({ icon, title, description, action, className }) => (
  <div className={className || "card-clay text-center py-12"}>
    {typeof icon === 'string' ? (
      <div className="text-6xl mb-4">{icon}</div>
    ) : (
      icon
    )}
    <h3 className="font-display text-lg font-semibold text-heading mb-2">{title}</h3>
    {description && (
      <p className={`text-sm text-secondary-text${action ? ' mb-6' : ''}`}>{description}</p>
    )}
    {action && action.to && (
      <Link to={action.to} className="btn-clay inline-flex items-center">{action.label}</Link>
    )}
    {action && action.onClick && (
      <button onClick={action.onClick} className="btn-clay-secondary">{action.label}</button>
    )}
  </div>
);

export default EmptyState;
